export const MESSAGE_RESOURCE = {
  // 充值到账提醒
  walletDeposit: 'WALLET_DEPOSIT',
  // 充值失败
  walletDepositFail: 'WALLET_DEPOSIT_FAIL',
  /** 调账 */
  adjustAccount: 'ADJUST_ACCOUNT',
  /**积分变动 */
  SELLER_CREDIT_CHANGED: 'SELLER_CREDIT_CHANGED',
  // COD账单结账（支付）
  COD_BILL_CHECK_OUT: 'COD_BILL_CHECK_OUT',
  // OS运费账单推送
  OS_FREIGHT_BILL_PAY: 'OS_FREIGHT_BILL_PAY',
  // OW运费账单推送
  OW_FREIGHT_BILL_PAY: 'OW_FREIGHT_BILL_PAY',
  // OW仓储账单推送
  OW_STORAGE_BILL_PAY: 'OW_STORAGE_BILL_PAY',
  // 倉儲帳單已發送
  OW_STORAGE_BILL_PUSH: 'OW_STORAGE_BILL_PUSH',
}

export const OPERATE_STATUS = {
  /** 成功 */
  success: 'SUCCESS',
  /** 失败 */
  fail: 'FAIL',
}
